<template>
  <div>
    <div class="aboutHistory">
      <div class="title">
        <span>当前位置：&nbsp;</span>
        <span>展会</span>
        <span>></span>
        <span>关于展会</span>
        <span style="margin: 0 9px">></span>
        <span>历史沿革</span>
      </div>
      <div class="content">
        <div class="content_top">{{ title }}</div>
        <div class="textDiv ql-editor" v-html="content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import video_ from "./Player";
export default {
  components: {
    video_,
  },
  data() {
    return {
      title: "",
      content: "",
      imgSrc: "",
    };
  },
  mounted() {
    this.$http({
      url: "getInformationList",
      method: "post",
      params: {
        type: 15,
      },
    })
      .then(({ data }) => {
        let { code, informationByTypeList } = data;
        if (code === 0 && informationByTypeList.length > 0) {
          this.title = informationByTypeList[0].title;
          this.content = informationByTypeList[0].content.replace(
            /<img/g,
            "<img style='max-width: 100%;height: auto; crossOrigin; display: block; margin: 0 auto;' "
          );
          this.imgSrc = informationByTypeList[0].image;
        }
      })
      .catch((err) => console.log(err));
  },
  methods: {
    dataIncarico() {
      this.title = this.dataList[0].title;
      this.content = this.dataList[0].content.replace(
        /<img/g,
        "<img style='max-width: 100%;height: auto; crossOrigin; display: block; margin: 0 auto;' "
      );
      this.imgSrc = this.dataList[0].image;
    },

    currentChangeHandle(val) {
      this.pageIndex = val;
    },
    pageTz() {
      this.pageIndex = this.pageNum;
    },

    detail(id) {
      // this.eventId = id;
    },

    setEventId() {
      this.eventId = null;
    },
  },
};
</script>
<style lang="scss">
.aboutHistory {
}
</style>
<style lang="scss" scoped>
.aboutHistory {
  min-height: 1277px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 45px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3) {
      margin: 0 9px;
    }
  }
  .content {
    width: 857px;
    min-height: 984px;
    margin: 10px auto 21px;
    .content_top {
      font-size: 28px;
      color: #000000;
      font-weight: bold;
      text-align: center;
     /* height: 28px; */
      line-height: 45px;
      margin: 48px 0 0 0;
      padding-bottom: 34px;
      border-bottom: 1px solid #e5e5e5;
    }
    .textDiv {
      min-height: 150px;
      margin: 33px 0 77px 0;
       /deep/ p {
        text-indent: 30px;
      }
    }
  }
}
</style>